import { useListCRUD } from 'lib/swr-crud';
import httpClient, { getResponseData } from 'lib/httpClient';

const fetchers = {
  read: async (url, query) => {
    try {
      const response = await httpClient({
        method: 'get',
        url,
        query,
      });

      return getResponseData(response);
    } catch (error) {
      throw error;
    }
  },
};

const useTags = ({ page, sizePerPage }) => {
  const url = `/tags`;

  const { data, error, isLoading, mutate } = useListCRUD(url, 'id', {
    fetchers,
    query: {
      per_page: sizePerPage,
      page,
    },
  });

  const tags = data?.data || [];
  const total = data?.meta?.total;

  return {
    tags,
    total,
    error,
    isLoading,
    mutate,
  };
};

export default useTags;
